enum BUILDER {
  ANDROID_BUILDER = 'android-builder',
  DYNAMIC_SCREEN_ANDROID_TOOLS = 'dynamic-screen-android-tools',
  DYNAMIC_SCREEN_IOS_TOOLS = 'dynamic-screen-ios-tools',
  IOS_BUILDER = 'ios-builder',
}

export const isUserId = (id: string): boolean => {
  const allowedBuilders: string[] = [
    BUILDER.ANDROID_BUILDER,
    BUILDER.IOS_BUILDER,
    BUILDER.DYNAMIC_SCREEN_ANDROID_TOOLS,
    BUILDER.DYNAMIC_SCREEN_IOS_TOOLS,
  ]
  return !allowedBuilders.includes(id)
}

export const formatBuilder = (builder: string): string => {
  switch (builder) {
    case BUILDER.ANDROID_BUILDER:
      return 'Android Builder'
    case BUILDER.IOS_BUILDER:
      return 'iOS Builder'
    case BUILDER.DYNAMIC_SCREEN_ANDROID_TOOLS:
      return 'Dynamic screen android tools'
    case BUILDER.DYNAMIC_SCREEN_IOS_TOOLS:
      return 'Dynamic screen ios tools'
    default:
      return 'builder'
  }
}
